<div class="card" [ngClass]="{'he': currentLanguage === 'he'}">
  <div #dvc class="dataview-container">
    <div *ngIf="isLoading" class="skeleton-container">
      <div class="loading-icon-container">
        <i class="fa-solid fa-person-digging fa-shake"></i>
      </div>
      <div class="skeleton-item" *ngFor="let i of [0, 1, 2, 3]">
        <p-skeleton width="100%" height="150px"></p-skeleton>
      </div>
    </div>


    <p-dataView *ngIf="!isLoading" #dv [value]="isLoading ? [] : entities" [layout]="'list'" [rows]="50"
      [paginator]="true" [loading]="isLoading"    [emptyMessage]="isLoading 
      ? '' : ('iaa.app.results.noResults' | translate)"    
      (onPage)="handlePageChange($event)" [first]="entityIndex" [showCurrentPageReport]="!isLoading" filterBy="title"
      [currentPageReportTemplate]="currentLanguage === 'he' ? 'מציג {first} עד {last} מתוך {totalRecords} רשומות' : '{first} to {last} of {totalRecords} records'">
      <ng-template pTemplate="list" let-entities>
        <ul>
          <li class="col-12 card-container" *ngFor="let entity of entities; trackBy: trackByEntityId">
             <div class="content" [ngClass]="{'content-he': currentLanguage === 'he', 'content-en': currentLanguage === 'en'}">
              <div [ngClass]="{'img-container':true, 'img-container-first': currentLanguage === 'he', 'img-container-last': currentLanguage === 'en'}">
                <div class="image-container">
                  <img *ngIf="entity.imageUrl" class="w-7rem h-full shadow-2 block border-round text-right image"
                    id="{{entity.entityId}}" [src]="entity.imageUrl" [alt]="((entity.title | translateLang | async) ?? '')"
                    (error)="setDefaultPic($event)" />
                </div>
                <div class="icon-container-left">
                  <i *ngIf="((entity.entityType === 'photogrammetric_model' && internalUser) || entity.entityType === 'dana_pdf' || entity.entityType === 'decision_letters') && entity.downloadUrl" class="pi pi-download download-icon" 
                    (click)="menuItemsService.downloadFile(entity)"
                    (keydown.enter)="menuItemsService.downloadFile(entity)" 
                    tabindex="0" 
                    role="button"
                    style="cursor: pointer;"
                    [attr.aria-label]="'iaa.general.download' | translate"></i>
                  <span *ngIf="entity.shapes.length > 0 || entity.entityType === 'orthophoto'" (click)="goToMap(entity)" (keydown.enter)="goToMap(entity)" tabindex="0" 
                    role="button"
                    [attr.aria-label]="'iaa.app.results.resultsBody.resultsBodyList.viewOnMap' | translate"
                    style="cursor: pointer; display: inline-flex; align-items: center;">
                    <img [src]="'assets/entity-location-gold.svg'" [attr.aria-label]="'iaa.general.mapIcon' | translate" width="20" height="22" class="map-icon" style="display: block;">
                  </span>
                </div>
              </div>
              <div class="details-container">
                <div class="entity-details">
                  <div class="row">
                    <div class="detail-title">{{'iaa.general.sourceType' | translate}}  </div>
                    <div class="detail-value" [pTooltip]="(entity.entityTypeName | translateLang | async) ?? ''">{{ entity.entityTypeName | translateLang | async }}</div>
                  </div>
                  <div class="row">
                    <div class="detail-title">{{'iaa.general.title' | translate}}</div>
                    <div class="detail-value" [pTooltip]="((entity.title | translateLang | async) ?? '')">
                      <button *ngIf="entity.linkInfo || entity.downloadUrl; else noLink" (click)="handleClickDetails(entity, $event)"
                        (keydown.enter)="handleClickDetails(entity, $event)" class="title-link" aria-haspopup="dialog"
                        [attr.data-entity-id]="entity.entityId">
                        {{(entity.title | translateLang | async) | slice:0:50}}
                        <span *ngIf="(((entity.title | translateLang | async) ?? '') .length) > 50">…</span>
                      </button>
                      <ng-template #noLink>
                        <bdi [pTooltip]="((entity.title | translateLang | async) ?? '')">
                          {{ ((entity.title | translateLang | async) ?? '') | slice:0:50 }}
                          <span *ngIf="(((entity.title | translateLang | async) ?? '') .length) > 50">…</span>
                        </bdi>
                      </ng-template>
                    </div>
                  </div>
                  <div class="row">
                    <div class="detail-title">{{'iaa.app.results.resultsBody.resultsBodyList.terms' | translate}} </div>
                    <div class="detail-value" [pTooltip]="(entity.thesaurusString | translateLang | async) ?? ''"><bdi>
                        <div *ngIf="(entity.thesaurusString | translateLang | async) as translatedThesaurus">
                          {{ translatedThesaurus.length > 100 ? (translatedThesaurus | slice:0:100) + '...' : translatedThesaurus || '' }}
                        </div>                        
                    </bdi></div>
                  </div>
                  <div class="row" *ngIf="entity.description">
                    <div class="detail-title">{{'iaa.app.results.resultsBody.resultsBodyList.details' | translate}} </div>
                    <div class="detail-value" [pTooltip]="((entity.description | translateLang | async) ?? '')">
                    <bdi>
                      {{ ((entity.description | translateLang | async) ?? '') | slice:0:100 }}
                      <span *ngIf="(((entity.description | translateLang | async) ?? '') .length) > 100">…</span>
                    </bdi>
                  
                  </div>
                  </div>
                  <div class="row">
                    <div class="detail-title">{{'iaa.general.licenses' | translate}} </div>
                    <div class="detail-value" [pTooltip]="entity.licensesString">
                      <div [style.direction]="currentLanguage === 'he' ? 'ltr' : 'inherit'" [style.text-align]="currentLanguage === 'he' ? 'right' : 'inherit'">
                        {{ entity.licensesString?.length > 100 ? (entity.licensesString | slice:0:100) + "..." : entity.licensesString }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div aria-live="polite" class="sr-only">
          {{currentLanguage === 'he'}} ? 
          מציג {{ (dv?.first ?? 0) + 1 }} עד {{ (dv?.first ?? 0) + (dv?.rows ?? 0) }} מתוך {{ dv?.totalRecords ?? 0 }} רשומות
          : {{ (dv?.first ?? 0) + 1 }} to {{ (dv?.first ?? 0) + (dv?.rows ?? 0) }} of {{ dv?.totalRecords ?? 0 }} records
        </div>
      </ng-template>
    </p-dataView>
  </div>
</div>